import { getFileExtension } from "lib/actions/files";
import { getAssetVersionFromResponse } from "lib/actions/assets/getAssetVersionFromResponse";
import { AssetWithVersionsModel } from "lib/types/assets/AssetWithVersionsModel";

export function getAssetFromResponse(r): AssetWithVersionsModel {
  const versions = r.versions.map(getAssetVersionFromResponse);
  const extension = getFileExtension(r.name);
  const nameWithoutExtension =
    (extension && r.name.slice(0, -(extension.length + 1))) || r.name;

  return {
    id: r.id,
    projectId: r.projectId,
    type: r.type,
    name: r.name,
    nameWithoutExtension,
    extension,
    aliasName: r.aliasName,
    versions,
    canEdit: r.canEdit,
    canDelete: r.canDelete,
  };
}
